module.exports = __webpack_public_path__ + "056046455e9b351204dbf835b4c2f870.pdf";